// 2026-05-26 - FormuLearning - Step 5 §5.2 DoE 방식 선택
// 파일 위치: frontend/src/features/step5/DoeSelectSection.tsx
// 2026-11-03 수정 - 이슈 #114: viewer 는 DoE 방식 선택(저장) 비활성.

import { useCanWrite, READ_ONLY_TITLE } from '../../hooks/useCanWrite'

type DoeType = 'ccd' | 'box_behnken' | 'mixture'

interface Props {
  selected: DoeType | null
  onSelect: (t: DoeType) => void
}

const METHODS: { value: DoeType; label: string }[] = [
  { value: 'ccd', label: 'CCD' },
  { value: 'box_behnken', label: 'Box-Behnken' },
  { value: 'mixture', label: 'Mixture' },
]

export default function DoeSelectSection({ selected, onSelect }: Props) {
  const canWrite = useCanWrite()
  return (
    <div className="mb-4">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">
        DoE Method
      </h4>
      <div className="flex gap-2">
        {METHODS.map((m) => (
          <button
            key={m.value}
            onClick={() => onSelect(m.value)}
            disabled={!canWrite}
            title={canWrite ? undefined : READ_ONLY_TITLE}
            className="rounded px-4 py-2 text-[11px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60"
            style={
              selected === m.value
                ? { background: 'var(--bg-chip-teal)', color: 'var(--color-accent-teal)', border: '1px solid var(--border-teal)' }
                : { color: 'var(--color-text-secondary)', border: '1px solid var(--border-soft)' }
            }
          >
            {m.label}
          </button>
        ))}
      </div>
    </div>
  )
}
